import {ReactNode, useState} from "react";
import classNames from "classnames";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {Svg} from "@/shared/ui/Svg";
import styles from "./FilterDropdown.module.scss";

type Props = {
    title: ReactNode;
    children: ReactNode;
    className?: string;
    triggerClassName?: string;
    titleClassName?: string;
    contentClassName?: string;
    iconLeft?: ReactNode;
    iconRight?: ReactNode;
    disabled?: boolean;
    isDesktop?: boolean;
    defaultOpen?: boolean;
    opened?: boolean;
    onOpenChange?: (opened: boolean) => void;
    onMobileOpen?: () => void;
    filterType?: "default" | "sort";
};

export const FilterDropdown = (
    {
        title,
        children,
        className,
        triggerClassName,
        titleClassName,
        contentClassName,
        iconLeft,
        iconRight,
        disabled = false,
        isDesktop = false,
        defaultOpen = false,
        opened,
        onOpenChange,
        onMobileOpen,
        filterType = "default",
    }: Props
) => {
    const isControlled = opened !== undefined;
    const [internalOpen, setInternalOpen] = useState(defaultOpen); const isOpen = isControlled ? opened : internalOpen;

    const changeOpen = (nextState: boolean) => {
        if (!isControlled) {
            setInternalOpen(nextState);
        }
        onOpenChange?.(nextState);
    };

    const closeDropdown = () => {
        changeOpen(false);
    };

    const toggleDropdown = () => {
        if (disabled) {
            return;
        }

        if (!isDesktop) {
            onMobileOpen?.();
            return;
        }

        changeOpen(!isOpen);
    };

    const rightIcon = iconRight ?? (
        <Svg id={`arrowDown`} className={classNames(styles.iconRight, {[styles.rotated]: isOpen})} />
    );

    const containerClassNames = classNames(
        styles.container,
        styles[filterType],
        className,
        {
            [styles.opened]: isOpen,
            [styles.disabled]: disabled,
        }
    );
    const triggerClassNames = classNames(styles.trigger, triggerClassName);
    const titleClassNames = classNames(styles.title, titleClassName);
    const contentClassNames = classNames(styles.content, contentClassName);

    return (
        <ClickAwayListener onClickAway={closeDropdown}>
            <div className={containerClassNames}>
                <button type={`button`} className={triggerClassNames} onClick={toggleDropdown}>
                    {iconLeft && (iconLeft)}
                    <span className={titleClassNames}>{title ?? "Фильтр"}</span>
                    {isDesktop && !iconLeft && (rightIcon)}
                </button>
                {isDesktop && isOpen && (<div className={contentClassNames}>{children}</div>)}
            </div>
        </ClickAwayListener>
    );
};
